import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_CON018_Request,
  IAPI_CON018_Response,
} from "../../../type/apiType";

// 従業状況一覧参照API
const httpIAPI_CON018 = async (
  param: IAPI_CON018_Request
): Promise<IAPI_CON018_Response> => {
  let res = await http.post(ApiUrl.API_CON018, {
    ...param,
  });

  return res.data;
};

export { httpIAPI_CON018 };
